module.exports = __webpack_public_path__ + "img/pic_15.810fe0a6.jpg";